import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { MerchandiseService } from '@epicuro-next/data/merchandise';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, map } from 'rxjs';

@Component({
  selector: 'epc-auth-support',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  standalone: false,
})
export class SupportComponent implements OnInit {
  private modal = inject(NgbActiveModal);
  private merchandiseService = inject(MerchandiseService);

  public content$ = new BehaviorSubject<string>('');
  public loading$ = new BehaviorSubject<boolean>(false);

  public ngOnInit(): void {
    this.loading$.next(true);
    this.merchandiseService
      .getSupportPage()
      .pipe(map((response) => response[0].html))
      .subscribe((html: string) => {
        this.content$.next(html ?? '');
        this.loading$.next(false);
      });
  }

  public close() {
    this.modal.close();
  }
}
